import { useWebSocketService, useUnityAPI } from '@/hooks';
import { selectedClientAtom } from '@/state/clients';
import { fetchDollhousePresignUrlAtom } from '@/state/unity';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useUnityContext, Unity } from 'react-unity-webgl';
import { CardWidget } from '../../../components/ui/card-widget';

interface DollHouseProps {
  width?: string | number;
  height?: string | number;
}

export const DollHouse = ({ width = 600, height = 450 }: DollHouseProps) => {
  // Get the base URL to ensure Unity files are loaded from the correct path
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const fetchDollhouseUrl = useSetAtom(fetchDollhousePresignUrlAtom);

  const {
    unityProvider,
    // loadingProgression,
    isLoaded,
    sendMessage,
  } = useUnityContext({
    loaderUrl: `${baseUrl}/build/sauron.loader.js`,
    dataUrl: `${baseUrl}/build/sauron.data`,
    frameworkUrl: `${baseUrl}/build/sauron.framework.js`,
    codeUrl: `${baseUrl}/build/sauron.wasm`,
  });

  const selectedClient = useAtomValue(selectedClientAtom);
  const { data, isConnected, error } = useWebSocketService(
    selectedClient?.machine_id || '',
  );
  const { sendEventToUnity } = useUnityAPI();
  const [isUnityReady, setIsUnityReady] = useState(false);

  const onUnityReady = (_event: CustomEvent) => {
    setIsUnityReady(true);
  };

  useEffect(() => {
    // Add event listener for the custom event
    window.addEventListener(
      'LoadingManagerReady',
      onUnityReady as EventListener,
    );

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('onUnityReady', onUnityReady as EventListener);
    };
  }, []);

  useEffect(() => {
    if (isConnected && data && isLoaded) {
      sendEventToUnity(0, JSON.stringify(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isConnected, isLoaded]);

  useEffect(() => {
    async function fetchSceneUrl() {
      if (isUnityReady && selectedClient?.machine_id) {
        try {
          const sceneUrl = await fetchDollhouseUrl({ 
            machineId: selectedClient.machine_id 
          });
          sendMessage('Root', 'LoadScene', sceneUrl);
        } catch (error) {
          console.error('Error loading scene:', error);
        }
      }
    }
    fetchSceneUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnityReady, selectedClient?.machine_id]);

  return (
    <CardWidget padding={false} className="flex justify-center">
      {/* {isConnected ? <p>Connected</p> : <p>Disconnected</p>} */}
      {error && <p>Error: {error}</p>}
      <Unity
        unityProvider={unityProvider}
        style={{ width, height, visibility: isLoaded ? 'visible' : 'hidden' }}
      />
    </CardWidget>
  );
};
